import { Icon, IconName } from '@usealloy/component-library';
import { useContext, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { filterNotifications } from '~/dashboard/components/helpers';
import { NotificationsContext } from '~/dashboard/context';
import { routes } from '~/helpers/routes';

import { Sidebar } from '../component/Sidebar';
import { ResourcesMenuItem } from './ResourcesMenuItem';
import { isPrefixActive } from './routeMatchers';

/**
 * "Settings" nav group — Settings, Notifications, and Resources.
 *
 * Mirrors the FE2.0 SideNav `NavList.settings` structure. The Settings condition is
 * ported verbatim from the legacy sidebar; Notifications is new to the sidebar (FE2.0
 * parity — the Topbar bell remains) with its unread badge derived the same way as the
 * Topbar's `NotificationDropdown`; Resources ports the legacy dropdown.
 */
export const SettingsGroup = () => {
  const { notifications } = useContext(NotificationsContext);
  const { pathname } = useLocation();


  const unreadNotificationsCount = useMemo(
    () => filterNotifications(notifications)?.filter(
      ({ viewed }) => viewed === false,
    ).length || 0,
    [notifications],
  );

  return (
    <Sidebar.Group style={{ marginTop: 'auto' }}>
      <Sidebar.Menu>
        <Sidebar.MenuItem>
          <Sidebar.MenuButton
            as={Link}
            data-dd-action-name="alloydd-sidebar-nav-notifications"
            isActive={isPrefixActive(
              routes.v3.dashboard.notifications.list,
              pathname,
            )}
            to={routes.v3.dashboard.notifications.list}
            tooltip="Notifications"
          >
            <Icon icon={IconName.Bell} size="large" />
            <span className="fs-unmask">Notifications</span>
          </Sidebar.MenuButton>
          {unreadNotificationsCount > 0 && (
            <Sidebar.MenuBadge value={unreadNotificationsCount} />
          )}
        </Sidebar.MenuItem>

        <ResourcesMenuItem />
      </Sidebar.Menu>
    </Sidebar.Group>
  );
};
